import React, { useEffect, useState } from 'react'; import './style.scss';
import { CircularProgress } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { clearSession } from '../../services/session.service';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from '../../store/store';
import { setIsRefresh, setUserJiraState, setUserState } from "../../store/userSlice";
import { getJiraAccessToken, getJiraRedirectUrl, getJiraToken, getNewAccessAndRefreshToken, validateUser } from '../../services/jira.service';
import { listenToAuthCodeChanges } from '../../utils/helper';

const JiraLoginComponent = ({
  handleRerender,
}: {
  handleRerender?: () => void;
}) => {
    const [jiraLoggedInUser, setJiraLoggedInUser] = useState('');
    const [loader, setLoader] = useState(false);
    const uniqueId = uuidv4();
    const userState = useSelector((state: RootState) => state.user);
    const dispatch = useDispatch();

    useEffect(() => {
        console.log('REGISTER_MESSAGE_OP');

        if (userState.jiraState === 'null') {
            dispatch(setUserJiraState(uuidv4()));
        }

        jiraUserAuthentication();
        // listenToAuthCodeChangesInJira();

        const access_token = localStorage.getItem("jiraAccessToken");
        if (!access_token) {
            jiraLoggedInEvent();
        }
    }, []);

    useEffect(() => {
        handleRerender?.();
    }, [jiraLoggedInUser]);

    useEffect(() => {
        console.log('[TESTING] JIRA STATE', userState.jiraState);
        if (userState.jiraState !== 'null') {
            listenToAuthCodeChanges(
                'jira',
                userState.jiraState,
                getJiraToken,
                setJiraLoggedInUser,
                getNewAccessAndRefreshToken,
                dispatch
            );
        }
    }, [userState.jiraState])

    const jiraUserAuthentication = () => {
        const authToken = localStorage.getItem('authCode');
        if (!authToken) {
            // clearSession();
            // window.location.href = '/notFound';
        }
    };

    const jiraLoggedInEvent = async () => {
        try {
            setLoader(true);
            const refresh_token = localStorage.getItem("jiraRefreshToken");
            if (refresh_token) {
                const { data } = await getJiraAccessToken(refresh_token);
                if (data && data.refresh_token && data.access_token) {
                    const isValidUser = await validateUser(data.access_token);
                    if (isValidUser && isValidUser.data && isValidUser.data.accountId) {
                        setJiraLoggedInUser(isValidUser.data.displayName);
                        dispatch(setIsRefresh(!userState?.user?.isRefresh));
                        localStorage.setItem('jiraAccessToken', JSON.stringify(data?.access_token));
                        localStorage.setItem('jiraRefreshToken', JSON.stringify(data.refresh_token));
                        console.log("[TESTING] Jira token set in local")
                    }
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoader(false);
        }
    };

    const getUrl = () => {
        getJiraRedirectUrl()
            .then((response: any) => {
                if (response.statusCode === 200 && response.data) {
                    console.log('[JIRA_SEND_STATE]', userState.jiraState);
                    const url = response.data;
                    const windowFeatures = 'width=800,height=600,resizable=yes,scrollbars=yes';
                    const popup = window.open(url + `&state=${userState.jiraState}`, 'open project oauth', windowFeatures);
                    console.log("[TESTING] POPUP OPENED");
                    if (!popup) {
                        alert('Popup blocked by browser');
                    }
                }
            })
            .catch((error: any) => { });
    };

    return (
        <span className="jira-button-type">
            <button
                className="btn btn-lg btn-block social-g"
                // PMS Web UI is deprecated — login is disabled.
                // onClick={getUrl}
                disabled
            >
                <img className="jira-logo" alt="Way more logo" src="./mark-gradient-white-jira-software.svg" />
                <span className="jira-text">{jiraLoggedInUser ? (
                    <div>Connected as: <br /><strong>{jiraLoggedInUser}</strong></div>
                ) : (
                    <span>Jira</span>
                )}</span>
                {
                    loader && <CircularProgress style={{ color: 'white' }} size='1.5rem' />
                }
                <img className="jira-add-icon" alt="Add icon" src="./plus-icon.png" />
                <img className="jira-way-more-logo" alt="Way more logo" src="./waymore-logo.png" />
            </button>
        </span>
    );
}

export default JiraLoginComponent;
